import { Box } from '@mui/material';
import { cloneElement } from 'react';

import { VendorActivationStatus } from 'entities/Vendors';

import { STATUS_CONFIG } from '../lib/config/supplierStatusConfig';

interface SupplierStatusIconProps {
    status: VendorActivationStatus;
}

export const SupplierStatusIcon = ({ status }: SupplierStatusIconProps) => {
    const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG];

    if (!config) return null;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {cloneElement(config.icon, {
                sx: {
                    fontSize: '16px !important',
                    color: `${config.color} !important`,
                },
            })}
        </Box>
    );
};
